import type { Filter, SpreadsheetDefinition } from 'common/types/summaryDefinitions';
import { FilterTypeSelection, ModelFilterType } from 'dashboard409a/components/ModelsTable/ModelsTable.types';
import { TrailingMonthsOption } from 'dashboard409a/pages/Workboard/common/trailingDates';

export type WorkboardGroupBy = 'companies';

export interface WorkboardTableDefinition {
  columns: Record<number, string>;
  sortKeys: SpreadsheetDefinition['sortKeys'];
  groupBy: WorkboardGroupBy;
  filters: Filter[];
  filterExclusions?: string[];
  columnWidths?: { column: string; width: number }[];
}
export interface ViewUserId {
  userId: number;
  groupId: string | null;
}

export type TableViewVisibility = 'private' | 'public';

export interface ModelView {
  id: string;
  name: string;
  preparerIds: ViewUserId[];
  reviewerIds: ViewUserId[];
  searchStatus: string | string[];
  fromDate: Date | null;
  toDate: Date | null;
  useTrailingDates?: boolean;
  trailingMonths?: TrailingMonthsOption;
  filterType?: ModelFilterType;
  filterTypeSelection?: FilterTypeSelection;
  columnVisibility?: Record<string, boolean>;
  visibility?: TableViewVisibility;
  createdBy?: number | null;
}


export interface ValuationView {
  id: string;
  name: string;
  columnVisibility?: Record<string, boolean>;
  groupByDeals?: boolean;
  visibility?: TableViewVisibility;
  createdBy?: number | null;
}


export const WORKBOARD_TABLE_VIEWS_QUERY_KEY = ['workboard-table-views', 'models'] as const;

export const WORKBOARD_VIEWS_MIGRATED_KEY = 'workboard-models-views-migrated';

export const WORKBOARD_VALUATIONS_VIEWS_MIGRATED_KEY = 'workboard-valuations-views-migrated';

export const getWorkboardValuationsViewsQueryKey = (sectionId?: string) =>
  ['workboard-table-views', 'valuations', sectionId ?? 'global'] as const;

// Meta filter column ids — not real table columns; used only in table_definition.filters
export const WORKBOARD_META_COLUMNS = {
  ASSIGNMENT: '_workboard_assignment',
  TRAILING_DATES: '_workboard_trailing_dates',
  GROUP_BY_DEALS: '_workboard_group_by_deals',
  SECTION: '_workboard_section',
} as const;
